import React, { Dispatch } from "react";
import { cx } from "emotion";
import { connect } from "react-redux";
import { Icon } from "../../Models/Icon";
import { IconSet } from "../../Models/IconSet";
import styles from "../../Styles/WorkflowImagePicker.module.scss";
import { images } from "../../Constants/workflowImages";
import { LoadingState, IAppState, ErrorDisplay, LoadingDisplay } from "../../../Common";
import { getWorkflowImageSets, setLoading } from "../../Actions/WorkflowImagesActions";

type Props = {
  icon: Icon;
  onIconPicked: (icon: Icon) => void;
  disabled?: boolean;
  isValid?: boolean;
};

type StateProps = {
  // workflow images stuff
  workflowImageSets: IconSet[];
  loadingState: LoadingState;
  errorMessage: string;
  errorCode?: number;
};

type State = {
  selectedImageGroupName?: string;
  hasLoadedDefaultGroup: boolean;
};

export default class WorkflowImagePicker extends React.Component<Props & StateProps, State> {
  static defaultProps = {
    disabled: false,
    isValid: true
  };

  constructor(props: Props & StateProps) {
    super(props);

    this.state = {
      hasLoadedDefaultGroup: false
    };
  }

  componentDidUpdate = () => {
    if (this.props.loadingState.isLoaded && !this.state.hasLoadedDefaultGroup) {
      let selectedGroupName: string | undefined;
      if (this.props.workflowImageSets.length) {
        // if we have an image chosen already, set the selected group to the group of that image
        // otherwise use the first group
        if (!this.props.icon) {
          selectedGroupName = this.props.workflowImageSets[0].name;
        } else {
          const groupsWithSelectedIcon = this.props.workflowImageSets.filter(wis => {
            return wis.images.filter(i => i.name === this.props.icon.name).length;
          });
          if (!groupsWithSelectedIcon.length) {
            selectedGroupName = this.props.workflowImageSets[0].name;
          } else {
            selectedGroupName = groupsWithSelectedIcon[0].name;
          }
        }
      }

      this.setState((prevState: State) => ({
        selectedImageGroupName: selectedGroupName,
        hasLoadedDefaultGroup: true
      }));
    }
  };

  handleIconPicked = (image: Icon) => {
    if (this.props.disabled) {
      return;
    }

    this.props.onIconPicked(image);
  };

  setSelectedGroup = (group: IconSet) => {
    this.setState((prevState: State) => ({
      selectedImageGroupName: group.name
    }));
  };

  render() {
    if (this.props.loadingState.isLoading) {
      return <LoadingDisplay />;
    }
    if (this.props.loadingState.errored) {
      return (
        <ErrorDisplay
          errorDescription={this.props.errorMessage}
          errorCode={this.props.errorCode}
          errorResult="Failed to load workflow JSON"
        />
      );
    }
    return (
      <div className={styles["image-picker"]}>
        <div
          className={cx(
            styles["image-picker-grid-container"],
            !this.props.isValid ? styles.invalid : undefined
          )}
        >
          <div className={styles["image-group-options"]}>
            {this.props.workflowImageSets.map(iconSet => {
              const isSelected = iconSet.name === this.state.selectedImageGroupName;
              const className = isSelected
                ? `${styles["image-group-option"]} ${styles["image-group-option-selected"]}`
                : styles["image-group-option"];
              return (
                <div
                  className={className}
                  key={iconSet.name}
                  onClick={() => {
                    this.setSelectedGroup(iconSet);
                  }}
                >
                  {iconSet.name}
                </div>
              );
            })}
          </div>

          {this.props.workflowImageSets
            .filter(set => set.name === this.state.selectedImageGroupName)
            .map(iconSet => (
              <div className={styles["image-picker-group"]} key={iconSet.name}>
                <div className={styles["image-picker-grid"]}>
                  {iconSet.images.map(icon => (
                    <div
                      key={icon.url}
                      className={cx(
                        styles["image-picker-item"],
                        this.props.icon && icon.name === this.props.icon.name
                          ? styles["image-picker-item-active"]
                          : undefined
                      )}
                      onClick={() => this.handleIconPicked(icon)}
                    >
                      <img src={icon.url} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          {/* <div className={styles["image-picker-grid"]}>
            {this.props.workflowImageSets.map(iconSet => (
              <div
                key={icon.url}
                className={cx(
                  styles["image-picker-item"],
                  this.props.icon && icon.name === this.props.icon.name
                    ? styles["image-picker-item-active"]
                    : undefined
                )}
                onClick={() => this.handleIconPicked(icon)}
              >
                <img src={icon.url} />
              </div>
            ))}
            {images.map(icon => (
              <div
                key={icon.url}
                className={cx(
                  styles["image-picker-item"],
                  this.props.icon && icon.name === this.props.icon.name
                    ? styles["image-picker-item-active"]
                    : undefined
                )}
                onClick={() => this.handleIconPicked(icon)}
              >
                <img src={icon.url} />
              </div>
            ))}
          </div> */}
        </div>
      </div>
    );
  }
}
